import React, {useEffect, useState} from 'react';
import {getLetterboxDecisions} from '../DropdownDataProviders' ;
import { renderDropdown, renderDropdownReadOnly} from "../DropdownFunctions";
import SpinnerDiv from "../SpinnerDiv";
import PropTypes from "prop-types";

const DropdownLetterboxDecisions = (props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        // This will bring a list of all users who qualify to be connected to the selected child
        getLetterboxDecisions().then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })
    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data)
    )
}

export default DropdownLetterboxDecisions;

DropdownLetterboxDecisions.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownLetterboxDecisions.propTypes = {
    onChange: PropTypes.func.isRequired
};